import { Colors } from '../../constants/Colors'
import { useAppSelector } from '../../hooks/redux'
import style from './Info.module.css'

interface Props {
    icon: string
    info: string
    requestI: string
}

const Info = ({
        icon,
        info,
        requestI
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.info}
            style={{
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].iconBackground
            }}
        >
            <div><i className={icon}></i> {info}</div>
            <div>{requestI}</div>
        </div>
    )
}

export default Info